export default {"src":"/_next/static/media/placeholder-7.d2f34e29.svg","height":190,"width":352};